import { ChevronRightIcon } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items, bgImage, title }) => {
  const backgroundStyle = bgImage
    ? { backgroundImage: `url(${bgImage})` }
    : {
        background:
          "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.08), transparent 40%), linear-gradient(120deg, #1a1f3c 0%, #0d1128 100%)",
      };

  return (
    <div
      className="relative bg-cover bg-center py-10"
      style={backgroundStyle}
    >
      {/* 🔹 Black Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-80"></div>
      <div className="mt-64 w-full max-w-7xl mx-auto">
        <div>
          <h1 className="text-white relative z-10 text-5xl font-bold tracking-wide mb-2">
            {title}
          </h1>
        </div>
        <nav
          className="relative z-10 py-3 px-0 rounded-md  text-white"
          aria-label="breadcrumb"
        >
          <ol className="flex items-center flex-wrap space-x-2 text-sm">
            {items.map((item, index) => (
              <li key={index} className="flex items-center">
                {index !== 0 && (
                  <ChevronRightIcon className="w-4 h-4 mx-2 text-gray-300" />
                )}
                {item.link ? (
                  <Link
                    to={item.link}
                    className="hover:text-red-400 transition-colors duration-200"
                  >
                    {item.name}
                  </Link>
                ) : (
                  <span className="font-medium">{item.name}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </div>
      {/* 🔹 Breadcrumb Content */}
    </div>
  );
};

export default Breadcrumb;
